module.exports = "/static/media/icon-note.28972a5f.svg";